"use client";

import React from "react";
import Button from "@/components/ui/Button";
import { TypographyH2 } from "@/components/shared";

function ErrorComponent({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  React.useEffect(() => {
    throw new Error(error.message);
  }, [error]);

  return (
    <div>
      <TypographyH2>Oops! Something went wrong...</TypographyH2>
      <Button
        onClick={() => {
          reset();
        }}
      >
        Try Again
      </Button>
    </div>
  );
}

export default React.memo(ErrorComponent);
